import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Header } from '../common_v2/components/Header';
import { Greeting } from '../common_v2/components/Greeting';
import { Footer } from '../common_v2/components/Footer';
import { useAuthentication } from '../LoginPage';
import { alertModal, isMobileScreen } from '@apply/ui';
import {
    PanelDemo,
    PanelHeaderDemo,
    ToggleButtonDemo,
    IconButtonDemo,
    TextBoxDemo,
    ExpanderDemo,
    FontStylesDemo,
    ButtonDemo,
    ProgressDonutDemo,
    MenuDemo,
    FlyoutMenuButtonDemo,
    SliderDemo,
    TabPanelDemo,
    GenericPopupDemo,
    MultilineTextBoxDemo,
    ProgressBreadcrumbListDemo,
    RadioPanelGroupDemo,
    DropDownBoxDemo,
    NumberBoxDemo,
    ProgressSpinnerDemo,
} from '@apply/components';

export interface ControlDemoProps {
    actions?: Actions;
}

export interface Actions {}

export const ControlDemo: React.FC<ControlDemoProps> = ({ actions }) => {
    const { isRegisteredUser, authentication } = useAuthentication();
    const [loading, setLoading] = useState<boolean>(false);
    const [loadError, setLoadError] = useState<string>('');

    useEffect(() => {
        setLoading(false);
        setLoadError('');
    }, [authentication?.username, actions]);

    useEffect(() => {
        if (loadError) {
            alertModal({
                message: 'An error has occurred while communicating with our server.  Please try your operation again.',
                onConfirm: () => {
                    setLoadError('');
                },
            });
        }
    }, [loadError]);

    return (
        <>
            {!loading && isRegisteredUser && authentication?.username ? (
                <>
                    <div className='app-container'>
                        <Header />
                        <main>
                            <div className='content'>
                                <div className='contentSection'>
                                    <div className={isMobileScreen() ? 'mobilePadding' : ''}>
                                        <Greeting user={authentication.user} />
                                        <FontStylesDemo />
                                        <PanelDemo />
                                        <PanelHeaderDemo />
                                        <ToggleButtonDemo />
                                        <IconButtonDemo />
                                        <TextBoxDemo />
                                        <DropDownBoxDemo />
                                        <NumberBoxDemo />
                                        <MultilineTextBoxDemo />
                                        <ExpanderDemo />
                                        <ProgressDonutDemo />
                                        <ButtonDemo />
                                        <MenuDemo />
                                        <FlyoutMenuButtonDemo />
                                        <SliderDemo />
                                        <TabPanelDemo />
                                        <GenericPopupDemo />
                                        <ProgressBreadcrumbListDemo />
                                        <RadioPanelGroupDemo />
                                        <ProgressSpinnerDemo />
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                    <Footer />
                </>
            ) : (
                <div
                    className='overlay'
                    data-testid='home-page-loading'
                >
                    <div className='overlay__inner'>
                        <div className='overlay__content'>
                            <span className='spinner'></span>
                            <span className='spinner-text'>Loading</span>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default connect(null)(ControlDemo);
